export enum FormValidationEnum {
    Required = "required",
    RequiredArray = "required-array",
    Regex = "regex",
    MaxLength = "maxtextlength",
    MinLength = "mintextlength",
    // current input required if target input has certain values
    RequiredIf = "requiredif",
    RequiredAll = "requiredall",
    // can be any of the above validations on current input,
    // but it will be applied based on a condition on a target input (conditions are defined in form-condition-validation-enum)
    // if condition true for target, apply validation to current input
    // example: if target input is not empty, make current input required
    Conditional = "conditional",
    DateIsNotAfter = "dateisnotafter", // For date inputs. User cannot select date after targetName.
    EncounterDeleteTimeFrameValidation = "encounterDeleteTimeFrameValidation", // Specifically created for encounters in GIP/CC note. Checks that encounter has no associated assessments before deleting.
    StartNewEncounter = "startNewEncounterValidation", // Specifically created for encounters in GIP/CC note. Checks that encounters have ended before starting next one.
    ListGroupLength = "listgrouplength", // Checks length of another listgroup before adding new item.
    ListGroupTimeOverLap = "listgrouptimeoverlap", // Inline validation that checks for time rage overlap in listgroup.
    DateIsNotInFuture = "dateisnotinfuture"
}
